// @flow
import moment from 'moment';

type SpotInventoryData = {
  date: moment,
  spotsToSell: number,
  spotsSold: number,
};

type SpotInventoryResponseData = {
  inventoryDate: moment,
  spots: number,
  soldSpots: number,
}

class SpotInventory {
  date: moment;
  spotsToSell: number;
  spotsSold: number;

  constructor({ date, spotsToSell, spotsSold }: SpotInventoryData) {
    this.date = date;
    this.spotsToSell = spotsToSell;
    this.spotsSold = spotsSold;
  }

  static parse({ inventoryDate, spots, soldSpots }: SpotInventoryResponseData) {
    return new SpotInventory({
      date: moment(inventoryDate),
      spotsToSell: spots,
      spotsSold: soldSpots,
    });
  }
}

export default SpotInventory;



// WEBPACK FOOTER //
// ./src/statsradio/modules/spots/domain/SpotInventory.js